import React from 'react';

const classGenders = {
    1: 'gender-man',
    2: 'gender-woman',
    3: 'gender-couple',
    4: 'gender-couple-lesbian',
    5: 'gender-couple-gay',
    6: 'gender-trav',
    guest: 'guest',
    group: 'group'
};

const BlockSelection = ({description = "", gender = "", selectOrientation = false, isActive = false, ...props}) => {
    return (
        <div className={`block-selection ${isActive ? 'active' : ''}`} {...props}>
            <div className={`inside-block ${classGenders[gender]}`}>
                {props.children}
                {description.length >= 1 && <span className={"description"}>{description}</span>}
            </div>
            {selectOrientation && (
                <div className={"orientation-selection-container"}>
                    <span className={`select-orientation ${classGenders[gender]}`}>Hétéro</span>
                    <span className={`select-orientation ${classGenders[gender]}`}>Homo</span>
                    <span className={`select-orientation ${classGenders[gender]}`}>Bi</span>
                </div>
            )}
        </div>
    )
};

export default BlockSelection;